import React from 'react';
import {
  StyledButton,
  ButtonRouterLink,
  ButtonLink,
  ChildWrapper,
} from './styledComponents';

export type Props = {
  className?: string;
  iconElem?: React.ReactNode;
  children?: React.ReactNode;
  to?: string;
  href?: string;
  borderRadius?: 'rounded' | 'slightlyRounded';
  type?: JSX.IntrinsicElements['button']['type'];
  disabled?: boolean;
  bgColor?: string;
  color?: string;
  onClick?: () => void;
};

const Button = ({
  bgColor = 'white',
  color = 'black',
  className,
  to,
  href,
  onClick,
  children,
  iconElem,
  borderRadius,
  type,
  disabled,
}: Props) => {
  const buttonChildrenElem = (
    <>
      {iconElem && <span>{iconElem}</span>}
      {children && (
        <ChildWrapper hasLeftMargin={!!iconElem}>{children}</ChildWrapper>
      )}
    </>
  );

  if (to) {
    return (
      <ButtonRouterLink
        className={className}
        tabIndex={0}
        to={to}
        onClick={onClick}
        borderRadius={borderRadius}
        disabled={disabled}
        bgColor={bgColor}
        color={color}
      >
        {buttonChildrenElem}
      </ButtonRouterLink>
    );
  } else if (href) {
    return (
      <ButtonLink
        className={className}
        href={href}
        rel='noopener noreferrer'
        tabIndex={0}
        onClick={onClick}
        borderRadius={borderRadius}
        disabled={disabled}
        bgColor={bgColor}
        color={color}
      >
        {buttonChildrenElem}
      </ButtonLink>
    );
  } else {
    return (
      <StyledButton
        className={className}
        tabIndex={0}
        onClick={onClick}
        borderRadius={borderRadius}
        type={type}
        disabled={disabled}
        bgColor={bgColor}
        color={color}
      >
        {buttonChildrenElem}
      </StyledButton>
    );
  }
};

export default Button;
